/**
  * Fact component
  *
  */
export default {
  name: 'fact',
  props: {
    /**
      * Name of the fact
      */
    name: {type: String, default: null}
  }
};
